// Libs
import { useEffect, RefObject } from 'react';

// Hooks
import { useLatestFunction } from '@hooks/useLatestFunction';

/** 

* Hook that calls callback in case of click outside of the element 

*/

export const useOutsideCallback = (
  ref: RefObject<HTMLElement>,
  cb: () => void,
  shouldClose?: (target: Element) => Boolean
) => {
  const updatedFunc = useLatestFunction(cb);

  useEffect(() => {
    function handleClickOutside(this: Document, event: MouseEvent) {
      const target = event.target as Node;
      const shouldBeClosed =
        !shouldClose || (shouldClose && shouldClose(target as Element));

      if (ref.current && !ref.current.contains(target) && shouldBeClosed) {
        updatedFunc();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};
